import { Injectable } from '@angular/core';

type AudBankTransferStorageKeys =
  | 'deposit'
  | 'bankdetail';
type AudBankTransferLocalStorageData = { [key in AudBankTransferStorageKeys]: any };

@Injectable({
  providedIn: 'root',
})
export class AudBankTransferDepositDataService {

  // keys for two-step deposit related local storage
  private STEP_AUD_TRANSFER_DEPOSIT = 'audTransferDeposit';

  // messages
  private LEAVING_PAGE_MSG =
    'Leaving this page will discard your payment progress. Would you like to continue your payment?';
  private SESSION_EXPIRED_MSG =
    'Your deposit session has expired. Please submit a new deposit request again.';
  private REDIRECT_PAGE_MSG =
    'You have an existing pending payment deposit. Would you like to continue your payment?';


  constructor() {}

  public getAudTransferDeposit(): string {
    return localStorage.getItem(this.STEP_AUD_TRANSFER_DEPOSIT);
  }

  public getLeavingPageMsg(): string {
    return this.LEAVING_PAGE_MSG;
  }

  public getSessionExpiredMsg(): string {
    return this.SESSION_EXPIRED_MSG;
  }

  public getRedirectPageMsg(): string {
    return this.REDIRECT_PAGE_MSG;
  }

  /**
   * Stores data related to the two-step deposit process in the local storage.
   *
   * @param data - An object containing the data to be stored in the local storage.
   * @param data.deposit - pending payment deposit.
   * @param data.bankdetails - The selected merchant bank details.
   */
  storeLocalStorageForAudTransfer(data: AudBankTransferLocalStorageData) {
    localStorage.setItem(
      this.STEP_AUD_TRANSFER_DEPOSIT,
      JSON.stringify(data)
    );

  }

  /**
   * Clears the step aud transfer storage data and reloads the page.
   * This function is used to clean up the local storage and refresh the page
   * when the user's deposit session has expired.
   */
  clearAudTransferLocalStorageAndReload() {
    this.clearAudTransferLocalStorage();
    window.location.reload();
  }

  /**
   * Clears the step aud transfer storage data by removing relevant deposit information.
   * This function is used to clean up the local storage when the user's deposit session has expired.
   */
  clearAudTransferLocalStorage() {
    localStorage.removeItem(this.STEP_AUD_TRANSFER_DEPOSIT);
  }
}
